import React from "react";
import "styles/App.scss";
import Root from "routes/rootRoute";

const App: React.FC = () => {
  return (
    <div className="app-wrapper">
      <Root />
    </div>
  );
};

export default App;
